const PREFIX = 'EMPLOYEE_LIST_';

export const EMPLOYEE_LIST_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;

export const EMPLOYEE_LIST_SUBMIT_FORM = `${PREFIX}SUBMIT_FORM`;

export const EMPLOYEE_LIST_SET_EMPLOYEES = `${PREFIX}SET_EMPLOYEES`;

export const EMPLOYEE_LIST_RESEND_INVITATION = `${PREFIX}RESEND_INVITATION`;

export const EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE = `${PREFIX}ASK_DELETE_EMPLOYEE`;

export const EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE = `${PREFIX}CANCEL_DELETE_EMPLOYEE`;

export const EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE = `${PREFIX}CONFIRM_DELETE_EMPLOYEE`;

export const EMPLOYEE_LIST_SET_DELETED_EMPLOYEE = `${PREFIX}SET_DELETED_EMPLOYEE`;

export const EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL = `${PREFIX}SHOW_DELETE_EMPLOYEE_MODAL`;

export const EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL = `${PREFIX}HIDE_DELETE_EMPLOYEE_MODAL`;

export const EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL = `${PREFIX}SHOW_ASSIGN_OUTLET_MODAL`;

export const EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL = `${PREFIX}HIDE_ASSIGN_OUTLET_MODAL`;

export const EMPLOYEE_LIST_SET_OUTLETS = `${PREFIX}SET_OUTLETS`;

export const EMPLOYEE_LIST_CHECK_ALL_OUTLETS = `${PREFIX}CHECK_ALL_OUTLETS`;

export const EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS = `${PREFIX}UNCHECK_ALL_OUTLETS`;

export const EMPLOYEE_LIST_SEARCH_OUTLET = `${PREFIX}SEARCH_OUTLET`;

export const EMPLOYEE_LIST_SET_CHECKED_OUTLETS = `${PREFIX}SET_CHECKED_OUTLETS`;

export const EMPLOYEE_LIST_ASSIGN_OUTLETS = `${PREFIX}ASSIGN_OUTLETS`;

export const EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS = `${PREFIX}CONFIRM_ASSIGN_OUTLETS`;

export const EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS = `${PREFIX}CANCEL_ASSIGN_OUTLETS`;

export const EMPLOYEE_LIST_SET_PROFILE = `${PREFIX}SET_PROFILE`;
